import { Search } from 'lucide-react';

import { GlassCard } from '../../app/components/ui/GlassCard';
import { CustomerList } from './components/CustomerList';
import { useCustomers } from './hooks/useCustomers';


export function CustomersPage() {

  const {
    customers,
    loading,
  } = useCustomers();


  return (
    <div className="flex flex-col gap-4 sm:gap-5">

      <div className="flex flex-col gap-1">
        <h1 className="text-lg font-semibold text-[var(--vania-colors-text-primary,#f5f6fa)]">
          مشتریان
        </h1>

        <p className="text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
          فهرست مشتریان و وضعیت سرویس‌های فعال آن‌ها.
        </p>
      </div>


      <div className="relative">

        <Search
          size={16}
          className="pointer-events-none absolute inset-y-0 end-3 my-auto text-[var(--vania-colors-text-secondary,#a3aab8)]"
        />

        <input
          type="search"
          placeholder="جستجوی مشتری..."
          className="w-full rounded-lg border border-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))] bg-[var(--vania-colors-surface-secondary,rgba(255,255,255,0.04))] py-2.5 ps-3 pe-9 text-sm text-[var(--vania-colors-text-primary,#f5f6fa)] placeholder:text-[var(--vania-colors-text-secondary,#6b7280)] outline-none focus:border-[var(--vania-accent-violet,#7c6cff)]"
        />

      </div>


      <GlassCard noPadding>

        {
          loading
          ?
          (
            <p className="px-5 py-6 text-center text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
              در حال دریافت مشتریان...
            </p>
          )
          :
          (
            <CustomerList customers={customers}/>
          )
        }

      </GlassCard>


    </div>
  );
}
